
jQuery(document).ready(function () {

    if (jQuery('body').hasClass('page-template-template-accueil')) {
        if (jQuery('section#expertise').length) {

            // Hide or show navbar depending on scroll
            var offset_bottom_beaute = jQuery('section#expertise').offset().top;
            var scroll_dist = 0;
            var nav_state = false;

            function manageNavbarState() {

                // if (jQuery(window).width() < 575) return;

                scroll_dist = jQuery(window).scrollTop();
                if (scroll_dist < 200) {
                    if (!nav_state) {
                        jQuery('header.navbar').removeClass('hide');
                        jQuery('header.navbar').removeClass('bgwhite');
                        jQuery('header.navbar .home_link').addClass('hide');
                        nav_state = true;
                    }
                }
                if (scroll_dist > 200 && scroll_dist < offset_bottom_beaute - 400) {
                    if (nav_state) {
                        jQuery('header.navbar').addClass('hide');
                        jQuery('header.navbar').removeClass('bgwhite');
                        jQuery('header.navbar .home_link').addClass('hide');
                        nav_state = false;
                    }
                }
                if (scroll_dist > offset_bottom_beaute - 400) {
                    if (!nav_state) {
                        jQuery('header.navbar').removeClass('hide');
                        jQuery('header.navbar').addClass('bgwhite');
                        jQuery('header.navbar .home_link').removeClass('hide');
                        nav_state = true;
                    }
                }
            }
            manageNavbarState();

            jQuery(window).on('scroll',function () {
                manageNavbarState();
            });

            // Update section offset on resize
            document.addEventListener('windowresize', (e) => {
                offset_bottom_beaute = jQuery('section#expertise').offset().top;
            }, false);

        }
    } else {
        jQuery('header.navbar').removeClass('hide');
    }

});


// Récupérez l'élément de menu
var tl = gsap.timeline({ paused: true });

function openNav() {
    animateOpenNav();

    var navBtn = document.getElementById("btnMenu");
    navBtn.onclick = function (e) {
        // Toggle reversed to it's opposite value
        tl.reversed(!tl.reversed());
        // Use the toggle method in the classList API
        navBtn.classList.toggle("active");

        if (jQuery('header.navbar').hasClass('opened')) {
            jQuery('header.navbar').removeClass('opened')
        } else {
            jQuery('header.navbar').addClass('opened')
        }

        if (jQuery('body').hasClass('menu-opened')) {
            jQuery('body').removeClass('menu-opened')
        } else {
            jQuery('body').addClass('menu-opened')
        }

    };

    jQuery('li.menu-item-has-children').on('click', function (e) {
        e.stopPropagation();
        jQuery('li.menu-item-has-children').not(this).attr('aria-expanded', 'false');
        jQuery(this).attr('aria-expanded', jQuery(this).attr('aria-expanded') == 'true' ? 'false' : 'true')

    })

    jQuery('li.menu-item-has-children > a').on('click', function (e) {
        e.preventDefault();
    })

}

function animateOpenNav() {
    var mobileNav = document.getElementById("menu");
    tl.to(mobileNav, {
        duration: 1,
        ease: "power3.out",
        x: '-100%'
    })
        .reverse(); // Finally reverse the timeline. reversed() is true
}

// init
openNav();


var menuElement = document.getElementById('menu');
// Ajoutez un écouteur d'événement `click` sur l'élément `body`
document.body.addEventListener('click', closeMenu);
document.body.addEventListener('keydown', closeMenuEscape);
menuElement.addEventListener('mouseenter', cancelCloseMenuTimeout);
menuElement.addEventListener('mouseleave', startCloseMenuTimeout);

// Créez la fonction de fermeture de menu
function closeMenu(event) {

    var navBtn = document.getElementById("btnMenu");
    // Vérifiez si l'élément cliqué est enfant de l'élément de menu
    if (!menuElement.contains(event.target) && !navBtn.contains(event.target)) {
        // Si ce n'est pas le cas, masquez le menu
        tl.to(menuElement, {
            duration: 1,
            ease: "power3.out",
            x: '-100%'
        }).reverse();
        jQuery('#btnMenu').removeClass('active');
        jQuery('header.navbar').removeClass('opened');
        jQuery('body').removeClass('menu-opened');
    }
}

function closeMenuEscape(event) {
    // Vérifiez si la touche "Echap" (Escape) a été pressée
    
    if (event.key === 'Escape' || event.keyCode === 27) {
        tl.to(menuElement, {
            duration: .5,
            ease: "power3.out",
            x: '-100%'
        }).reverse();
        jQuery('#btnMenu').removeClass('active');
        jQuery('header.navbar').removeClass('opened');
        jQuery('body').removeClass('menu-opened');
    }
}

function closeMenuOnMouseLeave(event){
    tl.to(menuElement, {
        duration: 1,
        ease: "power3.out",
        x: '-100%'
    }).reverse();
    jQuery('#btnMenu').removeClass('active');
    jQuery('header.navbar').removeClass('opened');
    jQuery('body').removeClass('menu-opened');
}

var closeMenuTimeout;
function startCloseMenuTimeout() {
    // Définissez une temporisation de fermeture du menu après 1 seconde
    closeMenuTimeout = setTimeout(closeMenuOnMouseLeave, 1000);
}

function cancelCloseMenuTimeout() {
    // Annulez la temporisation de fermeture du menu
    clearTimeout(closeMenuTimeout);
}